<div class="container-fluid p-0">
  <div class="row">
    <div class="col-12">
      <div class="login-card">
        <div>
         
          
          <div class="login-main"  >
            
            <form class="theme-form" [formGroup]="loginForm" (ngSubmit)="login()">
              <a class="logo" routerLink="/">
                <img class="img-fluid" src="assets/images/logo/logo-login.png" alt="Logo" >
              </a>
              <p class="text-center"><b>Ingresa tus credenciales para continuar</b></p>
              <div class="form-group">
                <label class="col-form-label">Usuario</label>
                <input class="form-control" type="text" required="" placeholder="matias@indesoft.com" formControlName="email" />
                
              </div>
              <div class="form-group">
                <label class="col-form-label">Contraseña</label>
                <input class="form-control" [type]="show ? 'text' : 'password'" formControlName="password" required="" placeholder="*********" />
                <div class="show-hide" (click)="showPassword()" *ngIf="!show"><span class="show"></span></div>
                <div class="show-hide" (click)="showPassword()" *ngIf="show"><span class="Hide"></span></div>
                <div *ngIf="loginForm.controls.password.touched && loginForm.controls.password.errors?.required" class="text text-danger mt-1">La contraseña es requerida</div>
              </div>
              <div class="form-group mb-0">
                             
                <div class="text-end mt-3">
                  <button class="btn btn-primary d-block w-100" [disabled]="!loginForm.valid || loading" type="submit">
                    <span *ngIf="!loading">Ingresar</span>
                    <span *ngIf="loading">
                      <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      Procesando...
                    </span>
                  </button>
                </div>
               
               
                
              </div>
              <h6 class="mt-4 or">Siguenos</h6>
              <div class="social mt-4 text-center">
                <div class="btn-showcase">                  
                  <a class="btn btn-light" target="_blank" href="https://www.facebook.com/people/Indesoft-AA/100063768360860/"> <app-feather-icons [icon]="'facebook'" class="txt-fb"></app-feather-icons>Facebook </a>
                  <a class="btn btn-light" target="_blank" href="https://www.instagram.com/inde.soft1?igsh=bmkzamx6cjZtZWly"> <app-feather-icons [icon]="'instagram'" class="txt-google"></app-feather-icons>Instagram </a>
                  
                  
                </div>
              </div>
               
              <p class="mt-4 mb-0 text-center">
                Desarrollado por
                <a href="https://indesoftsas.com/" target="_blank" rel="noopener noreferrer" class="ms-2">
                  <b>INDESOFT A&A SAS</b>
                </a>
              </p>
            </form>
           
            <app-adminseaf-loading *ngIf="loading"></app-adminseaf-loading>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
